// @noc/api — public surface.

export { ApiClient } from "./client.js";
export type { ApiClientOptions } from "./client.js";
export { makeAuthApi } from "./auth.js";
export type { AuthApi } from "./auth.js";
export { makeSearchApi } from "./search.js";
export type { SearchApi } from "./search.js";
export { makeRadiusApi } from "./radius.js";
export type { RadiusApi, RadiusLiveResult } from "./radius.js";
export { makeRadiusStatusApi } from "./radiusStatus.js";
export type { RadiusStatusApi } from "./radiusStatus.js";
export { makeIpPhoneApi } from "./ipPhone.js";
export type { IpPhoneApi } from "./ipPhone.js";
export { makeCallBlastApi } from "./callBlast.js";
export type { CallBlastApi } from "./callBlast.js";
export { makeBulkSmsApi } from "./bulkSms.js";
export type { BulkSmsApi, BulkSmsTemplate } from "./bulkSms.js";
export { makeSmsApi } from "./sms.js";
export type { SmsApi } from "./sms.js";
export { makeContactsApi } from "./contacts.js";
export type { ContactsApi } from "./contacts.js";
export { makeUsersApi } from "./users.js";
export type { UsersApi } from "./users.js";
export { makeMessengerApi } from "./messenger.js";
export type { MessengerApi } from "./messenger.js";
export { makeAudienceExportApi } from "./audienceExport.js";
export type {
  AudienceExportApi,
  AudienceExportPreview,
  AudienceExportStats,
  AudienceSegment,
} from "./audienceExport.js";
export { makeCustomerAuditApi } from "./customerAudit.js";
export type {
  CustomerAuditApi,
  CustomerLoginAttempt,
  CustomerLoginAttemptsResponse,
  CustomerLoginAttemptsFilter,
  CustomerLoginOutcome,
  CustomerSession,
  CustomerSessionsResponse,
  CustomerRevokeResponse,
} from "./customerAudit.js";
export { makeNetTestApi } from "./netTest.js";
export { makePppoeSessionsApi } from "./pppoeSessions.js";
export type {
  PppoeSessionsApi,
  PppoeSessionRow,
  PppoeSessionsResponse,
  PppoeSort,
  PppoeOrder,
  PppoeStatusFilter,
  PppoeListParams,
} from "./pppoeSessions.js";
export type {
  NetTestApi,
  NetTestReportListItem,
  NetTestReportListResponse,
  NetTestReportDetailResponse,
} from "./netTest.js";
export { makeRadiusPoolsApi } from "./radiusPools.js";
export type {
  RadiusPoolsApi,
  RadiusPool,
  RadiusPoolFamily,
  RadiusPackage,
  RadiusPoolsListResponse,
  RadiusPackagesListResponse,
  RadiusPoolsOpResponse,
  BackupRadiusStatus,
  BackupRadiusStatusResponse,
  BackupRadiusConfig,
  BackupRadiusConfigInput,
  BackupRadiusConfigResponse,
  BackupRadiusConfigSaveResponse,
} from "./radiusPools.js";
export { makeFleetApi } from "./fleet.js";
export type { FleetApi } from "./fleet.js";
export { makeSwitchesApi } from "./switches.js";
export type { SwitchesApi } from "./switches.js";
export { makeResellersApi } from "./resellers.js";
export type { ResellersApi } from "./resellers.js";
export { makeBoxChainsApi } from "./boxchains.js";
export type {
  BoxChainsApi,
  BoxChain,
  BoxChainNode,
  BoxChainListResponse,
  BoxChainAddResult,
  BoxChainStateNode,
  BoxChainStateChain,
  BoxChainTotals,
  BoxChainStateResponse,
  BoxChainOpResult,
} from "./boxchains.js";
export { makeOltIssuesApi } from "./oltIssues.js";
export type {
  OltIssuesApi,
  OltIssue,
  OltIssueType,
  OltIssueCounts,
  OltIssuesResponse,
  OltIssueFeedbackResult,
} from "./oltIssues.js";
export { makeRadiusIssuesApi } from "./radiusIssues.js";
export type {
  RadiusIssuesApi,
  RadiusIssue,
  RadiusIssueType,
  RadiusIssueCounts,
  RadiusIssuesResponse,
} from "./radiusIssues.js";
export { makeFiberApi } from "./fiber.js";
export type {
  FiberApi,
  DPKind,
  DistPoint,
  DPUpstream,
  DPUpstreamHop,
  CableSummary,
  CableDetail,
  CableJoint,
  CableUsage,
  SpanHop,
  SpanDetail,
  PONListing,
  TreeNode,
  TreeEdge,
  CapacityRow,
  FiberIssue,
  ODFRow,
  ODFSavePayload,
  ODFSaveResp,
  ODFDeleteResp,
  DPSavePayload,
  DPSaveResp,
  DPRefs,
  DPRefsResp,
  DPDeleteResp,
  CableSavePayload,
  CableSaveResp,
  SpanSavePayload,
  SpanHopSaveItem,
  SpanSaveResp,
  SpanDeleteResp,
  JointSavePayload,
  JointSaveResp,
  JointDeleteResp,
  DropRow,
  DropGetResp,
  DropSavePayload,
  DropSaveResp,
  DropDeleteResp,
} from "./fiber.js";
export { makeIpInfoApi } from "./ipInfo.js";
export type { IpInfoApi, IpGeo, IpInfoResult } from "./ipInfo.js";
export { makeCmdApi } from "./cmd.js";
export type {
  CmdApi,
  CmdResult,
  IfRateResult,
  OnuDetailResult,
  OnuRxResult,
  OltWriteResult,
  PingArgs,
  PingEntry,
  PingReport,
  PingResult,
  TorchEntry,
  TorchResult,
} from "./cmd.js";
export { ApiError } from "./types.js";
export type {
  User,
  LoginRequest,
  LoginResponse,
  MeResponse,
  RefreshResponse,
  SubscriberSession,
  SearchResponse,
  SuggestMatch,
  SuggestResponse,
  RadiusDetailsRow,
  RadiusDetailsResponse,
  DashboardTiles,
  DashboardTilesResponse,
  FleetCount,
  DashboardPollerWidget,
  DashboardPollerResponse,
  OltRow,
  OltAggs,
  OltsResponse,
  OltOnu,
  OltOnusResponse,
  OltPonPort,
  OltUplinkPort,
  OltPanel,
  OltPanelResponse,
  OltModel,
  OltModelsResponse,
  OltSaveRequest,
  OltSaveResult,
  OltDeleteResult,
  RouterRow,
  RouterAggs,
  RoutersResponse,
  RouterSaveRequest,
  RouterSaveResult,
  RouterDeleteResult,
  SwitchSummary,
  SwitchListResponse,
  SwitchUserRow,
  SwitchUsersResponse,
  RunRequest,
  RunResponse,
  RemoveMacBindResult,
  UpdateClientResult,
  BillingSummary,
  LedgerFull,
  RadiusHealth,
  RadiusBackendDescriptor,
  RadiusActionInput,
  RadiusActionDescriptor,
  RadiusCallRecord,
  RadiusConnectionStatus,
  RadiusBulkSyncStatus,
  RadiusRecentKick,
  RadiusKickerStatus,
  RadiusActionStatus,
  RadiusStatusState,
  RadiusStatusStateResponse,
  RadiusSaveRequest,
  RadiusSaveResult,
  RadiusTestResult,
  IPPhoneHealth,
  IPPhoneKindDescriptor,
  IPPhoneActionInput,
  IPPhoneActionDescriptor,
  IPPhoneCallRecord,
  IPPhoneConnectionStatus,
  IPPhoneActionStatus,
  IPPhoneSipTrunk,
  IPPhoneSipTrunks,
  IPPhoneVolte,
  IPPhonePerf,
  IPPhoneSection,
  IPPhoneServiceStatus,
  IPPhoneGatewayCard,
  IPPhoneState,
  IPPhoneStateResponse,
  IPPhoneSaveRequest,
  IPPhoneSaveResult,
  IPPhoneTestResult,
  IPPhoneRunRequest,
  IPPhoneRunResult,
  IPPhoneDeleteResult,
  CallBlastHealth,
  CallBlastBackendDescriptor,
  CallBlastVoice,
  CallBlastSender,
  CallBlastReport,
  CallBlastBatchPlanEntry,
  CallBlastMonthly,
  CallBlastConnection,
  CallBlastState,
  CallBlastStateResponse,
  CallBlastSubscriber,
  CallBlastNeedsFixResponse,
  CallBlastSaveRequest,
  CallBlastSaveResult,
  CallBlastTestResult,
  CallBlastRunRequest,
  CallBlastRunResult,
  CallBlastBatchResult,
  CallBlastGroupResult,
  CallBlastStartResponse,
  SmsKpis,
  SmsStamp,
  SmsMissedCall,
  SmsItem,
  SmsPageData,
  SmsMainResponse,
  Contact,
  ContactsListResponse,
  ContactAddResponse,
  ContactRemoveResponse,
  PortalRole,
  PortalUser,
  PortalUsersListResponse,
  PortalUserSaveRequest,
  PortalUserSaveResult,
  PortalUserDeleteResult,
  ResellerRosterRow,
  ResellersListResponse,
  MessengerConversation,
  MessengerConversationView,
  MessengerMessage,
  MessengerBubbleResponse,
  MessengerConversationResponse,
  MessengerStateResponse,
  MessengerSaveRequest,
  MessengerSaveResult,
  MessengerTestResult,
  MessengerSendResult,
  MessengerClaimResult,
  MessengerOpResult,
  MessengerTemplate,
  MessengerTemplateListResponse,
  MessengerTemplateSaveResponse,
  BulkSmsBackend,
  BulkSmsHealth,
  BulkSmsState,
  BulkSmsStateResponse,
  BulkSmsSaveRequest,
  BulkSmsSaveResponse,
  BulkSmsTestResponse,
  BulkSmsBalanceResponse,
  BulkSmsSendRequest,
  BulkSmsSendResponse,
  BulkSmsSendResult,
  BulkSmsJob,
  BulkSmsJobsResponse,
  BulkSmsJobMessage,
  BulkSmsJobDetailResponse,
  BulkSmsCampaign,
  BulkSmsCampaignListResponse,
  BulkSmsCampaignSaveResponse,
  BulkSmsRecipient,
  BulkSmsRecipientFilter,
  BulkSmsRecipientsResponse,
} from "./types.js";

// Convenience: build the whole API surface from one ApiClient.
import { ApiClient, type ApiClientOptions } from "./client.js";
import { makeAuthApi } from "./auth.js";
import { makeSearchApi } from "./search.js";
import { makeRadiusApi } from "./radius.js";
import { makeRadiusStatusApi } from "./radiusStatus.js";
import { makeIpPhoneApi } from "./ipPhone.js";
import { makeCallBlastApi } from "./callBlast.js";
import { makeBulkSmsApi } from "./bulkSms.js";
import { makeSmsApi } from "./sms.js";
import { makeContactsApi } from "./contacts.js";
import { makeUsersApi } from "./users.js";
import { makeMessengerApi } from "./messenger.js";
import { makeAudienceExportApi } from "./audienceExport.js";
import { makeCustomerAuditApi } from "./customerAudit.js";
import { makeRadiusPoolsApi } from "./radiusPools.js";
import { makeFleetApi } from "./fleet.js";
import { makeSwitchesApi } from "./switches.js";
import { makeResellersApi } from "./resellers.js";
import { makeBoxChainsApi } from "./boxchains.js";
import { makeOltIssuesApi } from "./oltIssues.js";
import { makeFiberApi } from "./fiber.js";
import { makeRadiusIssuesApi } from "./radiusIssues.js";
import { makeIpInfoApi } from "./ipInfo.js";
import { makeCmdApi } from "./cmd.js";
import { makeNetTestApi } from "./netTest.js";
import { makePppoeSessionsApi } from "./pppoeSessions.js";

export function createApi(opts: ApiClientOptions = {}) {
  const client = new ApiClient(opts);
  return {
    client,
    auth: makeAuthApi(client),
    search: makeSearchApi(client),
    radius: makeRadiusApi(client),
    radiusStatus: makeRadiusStatusApi(client),
    ipPhone: makeIpPhoneApi(client),
    callBlast: makeCallBlastApi(client),
    bulkSms: makeBulkSmsApi(client),
    sms: makeSmsApi(client),
    contacts: makeContactsApi(client),
    users: makeUsersApi(client),
    messenger: makeMessengerApi(client),
    audienceExport: makeAudienceExportApi(client),
    customerAudit: makeCustomerAuditApi(client),
    radiusPools: makeRadiusPoolsApi(client),
    fleet: makeFleetApi(client),
    switches: makeSwitchesApi(client),
    resellers: makeResellersApi(client),
    boxchains: makeBoxChainsApi(client),
    oltIssues: makeOltIssuesApi(client),
    fiber: makeFiberApi(client),
    radiusIssues: makeRadiusIssuesApi(client),
    ipInfo: makeIpInfoApi(client),
    cmd: makeCmdApi(client),
    netTest: makeNetTestApi(client),
    pppoeSessions: makePppoeSessionsApi(client),
  };
}

export type Api = ReturnType<typeof createApi>;
